var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.535 4.625L6.085 5.085C5.725 5.445 5.5 5.75 5.5 6.5H4.5V6.25C4.5 5.695 4.725 5.195 5.085 4.835L5.705 4.205C5.89 4.025 6 3.775 6 3.5C6 2.945 5.55 2.5 5 2.5C4.73478 2.5 4.48043 2.60536 4.29289 2.79289C4.10536 2.98043 4 3.23478 4 3.5H3C3 2.96957 3.21071 2.46086 3.58579 2.08579C3.96086 1.71071 4.46957 1.5 5 1.5C5.53043 1.5 6.03914 1.71071 6.41421 2.08579C6.78929 2.46086 7 2.96957 7 3.5C7 3.94 6.82 4.335 6.535 4.625ZM5.5 8.5H4.5V7.5H5.5M5 0C4.34339 0 3.69321 0.129329 3.08658 0.380602C2.47995 0.631876 1.92876 1.00017 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C1.92876 8.99983 2.47995 9.36812 3.08658 9.6194C3.69321 9.87067 4.34339 10 5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 2.235 7.75 0 5 0Z",
    fill: "black",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsIcon);
export default __webpack_public_path__ + "static/media/tipsIcon.67c07d1bb3699b66b2ae059bcef13202.svg";
export { ForwardRef as ReactComponent };